import { TimeUnit } from '../../../../../utils/apollo/graphqlSchema';
import { freeze } from '@reduxjs/toolkit';
import { assertCondition, hasProperty } from '../../../../../utils/types';

const SHORTCUT_DAY_LIST = [2, 7, 15, 28, 30, 60, 90, 180, 365];
const SHORTCUT_WEEK_LIST = [2, 4, 8, 12, 24];
const SHORTCUT_MONTH_LIST = [3, 6, 12];
const SHORTCUT_QUARTER_LIST = [2, 3, 4];
const SHORTCUT_YEAR_LIST = [2, 3, 4];

export const optionsByTimeUnit = freeze({
  [TimeUnit.Day]: SHORTCUT_DAY_LIST.map((value) => ({
    text: value.toString(),
    value,
  })),
  [TimeUnit.Week]: SHORTCUT_WEEK_LIST.map((value) => ({
    text: value.toString(),
    value,
  })),
  [TimeUnit.Month]: SHORTCUT_MONTH_LIST.map((value) => ({
    text: value.toString(),
    value,
  })),
  [TimeUnit.Quarter]: SHORTCUT_QUARTER_LIST.map((value) => ({
    text: value.toString(),
    value,
  })),
  [TimeUnit.Year]: SHORTCUT_YEAR_LIST.map((value) => ({
    text: value.toString(),
    value,
  })),
});

export const getOptionsByTimeUnit = (timeUnit: TimeUnit) => {
  assertCondition(hasProperty(optionsByTimeUnit, timeUnit));
  return optionsByTimeUnit[timeUnit];
};
